<ngx-loading [show]="loading"></ngx-loading>
<app-error *ngIf="errorMessage" [message]="errorMessage"></app-error>
<div class="modal-header">
  <h4 class="modal-title no-transform">Add Photo</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form *ngIf="addPhotoForm" [formGroup]="addPhotoForm" class="photo-form form-group" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <!-- Image -->
    <div class="row py-1">
      <div class="col">
        <div class="custom-file">
          <input
            *ngIf="!isServicePhoto && !singleImageSelect"
            type="file"
            class="custom-file-input"
            (change)="onFileChange($any($event.target).files)"
            accept="image/png, image/jpeg, image/heic, image/heif"
            multiple
          />
          <input
            *ngIf="isServicePhoto || singleImageSelect"
            type="file"
            class="custom-file-input"
            (change)="onFileChange($any($event.target).files)"
            accept="image/png, image/jpeg, image/heic, image/heif"
          />
          <label class="custom-file-label" for="addImage">
            <div *ngIf="filesSelected === selectedFiles.None">Choose File</div>
            <div *ngIf="filesSelected === selectedFiles.Single">
              {{ addPhotoForm.value.file.name }}
            </div>
            <div *ngIf="filesSelected === selectedFiles.Multiple">Multiple Files Selected</div>
          </label>
        </div>
        <ng-container *ngIf="displayPhotoCapture">
          <div class="text-center m-2">-OR-</div>
          <div>
            <label for="imageCapture" class="btn em-btn em-btn-green w-100">
              <i class="far fa-camera"></i> Capture Photo
            </label>
            <input
              id="imageCapture"
              type="file"
              (change)="onFileChange($any($event.target).files)"
              accept="image/*"
              capture="environment"
            />
          </div>
        </ng-container>
      </div>
    </div>
    <ng-container formGroupName="metadata">
      <!-- Name -->
      <div class="row py-1">
        <div class="col">
          <label class="mb-1" for="imageName">Image Name</label>
          <input type="text" class="form-control" id="imageName" formControlName="imageName" />
        </div>
      </div>
      <!-- Notes -->
      <div class="row py-1">
        <div class="col">
          <label class="mb-1" for="notes">Notes</label>
          <textarea class="form-control" rows="3" placeholder="Add notes" id="notes" formControlName="notes"></textarea>
        </div>
      </div>
      <!-- Tags -->
      <div *ngIf="!isClinicPhoto" class="row py-1">
        <div class="col">
          <tag-input [formControlName]="'tags'" name="tags" #input [onlyFromAutocomplete]="true">
            <ng-template let-item="item" let-index="index">
              <div class="tag-pill" [ngStyle]="{ 'border-color': pillColours[item.type] }">
                <ng-container *ngIf="item.title; else text">
                  {{ item.title }}
                </ng-container>
                <ng-template #text>
                  {{ item.display }}
                </ng-template>
                <delete-icon (click)="input.removeItem(item, index)"></delete-icon>
              </div>
            </ng-template>
            <tag-input-dropdown
              [focusFirstElement]="true"
              [autocompleteItems]="tagList"
              [zIndex]="99999"
              [displayBy]="'title'"
              [identifyBy]="'tagId'"
              [showDropdownIfEmpty]="true"
              [keepOpen]="false"
            >
            </tag-input-dropdown>
          </tag-input>
        </div>
      </div>
      <!-- Consent to share -->
      <div *ngIf="!isClinicPhoto" class="row py-1">
        <div class="col">
          <div class="form-check pl-0">
            <label for="consentToShare"> Consent to Share Photo(s) </label>
            <select
              id="photoConsentSelect"
              #photoConsentSelect
              class="form-control"
              (change)="setPhotoConsent()"
              formControlName="photoConsentTypeId"
            >
              <option *ngFor="let option of photoConsentOptions" [value]="option.value">{{ option.title }}</option>
            </select>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="row py-3">
      <div class="col text-center">
        <button type="submit" class="btn em-btn em-btn-green" [disabled]="uploadIsInvalid()">Upload</button>
      </div>
      <div *ngIf="patient && patient.avatar" class="col text-center">
        <button type="submit" class="btn em-btn em-btn-green" (click)="deleteAvatar()">Remove Avatar</button>
      </div>
    </div>
    <div *ngIf="isServicePhoto || showGallery" class="row py-3 photo-gallery">
      <div class="col text-center">
        <ngx-gallery [options]="galleryOptions" [images]="galleryImages" (change)="imageClicked($event)"></ngx-gallery>
      </div>
    </div>
  </div>
</form>
